import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { ManagerParkingTicketsPage } from './manager-parking-tickets.page';

const routes: Routes = [
  {
    path: '',
    component: ManagerParkingTicketsPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ManagerParkingTicketsPageRoutingModule {}
